const tr = {
  onboarding: {
    countryQuestion: "Anladım! 🌍\n\nHangi ülkedesiniz?",
    countryPlaceholder: "Hangi ülkedesiniz?",
    letsGo: "Hadi başlayalım!",
    summaryIntro: "🎉 Harika, {name}! Her şey hazır!",
    yourNameLabel: "adınız",
    baseLanguageLabel: "temel dil",
    goalsHint: "Kelime hedefinizi ve kurs süresini istediğiniz zaman Hedefler sayfasından ayarlayabilirsiniz.",
    startLearning: "{destLang} öğrenmeye başla!",
  },
  header: {
    learner: "Öğrenci",
    home: "🏠 Ana Sayfa",
    allLessons: "📚 Tüm Dersler",
    currentLesson: "📖 Güncel Ders",
    flashcards: "🃏 Flash Kartlar",
    progress: "📈 İlerleme",
    goals: "🎯 Hedefler",
    grammarLab: "📘 Dilbilgisi",
    more: "⋯ Diğer",
    myVocabulary: "📝 Kelime Dağarcığım",
    listenSpeak: "🎧 Dinle ve Konuş",
    signOut: "↩ Çıkış Yap",
  },
  lab: {
    title: "Dinle ve Konuş Laboratuvarı",
    back: "Geri",
    intro: "Daha önce çalıştığın bir konu hakkında Babi ile kısa bir sesli konuşma yap.",
    pickTopic: "Tamamladığın bir konu seç",
    noTopics: "Önce bir dersi tamamla, sonra konuşma pratiği yapmak için buraya geri dön.",
    level: "Seviye {level}",
    talkAbout: "Babi ile “{topic}” hakkında konuş",
    speedLabel: "Babi'nin hızı",
    speedNormal: "Normal",
    speedSlow: "Yavaş",
    speedNote: "Yavaş hız, aynı yanıt için daha fazla konuşma dakikanızı kullanır.",
    startConversation: "Konuşmayı başlat",
    tapToStart: "Mikrofona dokun ve Babi'ye Türkçe cevap ver.",
    continueConversation: "Soruyu cevapla",
    finishSession: "Bitir",
    voiceReviewHint: "Söylediğini kontrol et ve onayla — ya da yeniden dene.",
    voiceConfirm: "Onayla",
    voiceRedo: "Yeniden",
    voiceDenied: "Mikrofon erişimi olmadan ses kullanılamaz. Tekrar denemek için istediğiniz zaman mikrofon simgesine dokunun.",
    lowBalanceWarning: "Bu aylık döngü için konuşma dakikanız azalıyor.",
    thinking: "Babi düşünüyor…",
    complete: "Oturum tamamlandı",
    completeSub: "Güzel pratik. Başka bir konu hakkında konuşmak için istediğin zaman geri gel.",
    another: "Başka bir konu çalış",
    done: "Bitti",
    replyError: "Babi şu anda yanıt veremedi. Lütfen birazdan tekrar dene.",
    tryAgain: "Tekrar dene",
    eliteUpsellTitle: "Dinle ve Konuş bir Elite özelliğidir",
    eliteUpsellBody: "Pro planındasın. Babi ile konuşma pratiği yapmak için Ayarlar'dan Elite'e yükselt.",
    listenAgainButton: "Tekrar dinle",
    listenAgainPlaying: "Durdur",
    translateButton: "Çevir",
    translating: "Çevriliyor…",
    translateFailed: "Çevrilemedi — tekrar dene.",
    starsAriaLabel: "3 üzerinden {stars}",
    explainButton: "Daha fazla açıkla",
    explaining: "Açıklanıyor…",
    explainFailed: "Açıklama alınamadı — tekrar dene.",
    recapHeading: "Konuşma Raporu",
    recapTitle: "Özetin",
    recapAvgStars: "Bu oturumun ortalaması",
    recapTurnsCompleted: "{total} turdan {completed} tanesi tamamlandı",
    recapErrorFree: "{n} tur hatasız",
    recapMistakesByType: "Türe göre hatalar",
    recapCorrections: "Neler düzeltildi",
    voiceMinutesTitle: "Sesli konuşma dakikası",
    voiceMinutesLeft: "Bu dönemde {total} içinden {amount} kaldı",
    voiceMinutesNone: "Bu dönemde aylık dakika kalmadı",
  },
  dashboard: {
    greeting: "Merhaba, {name}! 👋",
    streakMsg: "{streak} günlük seri 🔥 — devam et!",
    noStreak: "Bugün ilk dersini başlat!",
    streakProtectionDays: "{n} Seri Koruma Günü kazanıldı 🛡️",
    dayInfo: "Ana dil: {lang} · {total} günün {day}. günü",
    dayStreak: "günlük seri",
    share: "Paylaş",
    wordsLearned: "Öğrenilen Kelimeler",
    lessonsDone: "Tamamlanan Dersler",
    goalComplete: "Hedef Tamamlama",
    timeStudied: "Çalışma Süresi",
    hoursUnit: "Saat",
    paceTitle: "📊 Günlük Tempo İzleyici",
    statusAhead: "🚀 {delta} kelime önde!",
    statusBehind: "⚡ {delta} kelime geride",
    statusOnTrack: "✅ Tam hedefte!",
    paceTarget: "Hedef: günde {wpd} kelime · Bugün: {today} kelime",
    paceExpected: "Beklenen: {n}",
    paceGoal: "Hedef: {n}",
    actionCurrentLesson: "Güncel Ders",
    actionAllLessons: "Tüm Dersler",
    actionFlashcards: "Flash Kartlar",
    actionProgress: "İlerlemem",
    actionGoals: "Hedeflerim",
    actionMyVocabulary: "Kelime Dağarcığım",
    actionGrammarLab: "Dilbilgisi Laboratuvarı",
    actionListenSpeak: "Dinle ve Konuş Laboratuvarı",
    lessonsSub: "{count} konu · {words} kelime",
    cardsDue: "Bugün {n} kart seni bekliyor!",
    allCaughtUp: "Hepsi tamam! 🎉",
    progressSub: "Grafikler, doğruluk, kelime büyümesi",
    myVocabSub: "Öğrendiğin tüm kelimelere göz at",
    listenSpeakSub: "Babi ile konuşma pratiği yap",
    goalsSub: "{words} kelime · {days} gün",
    apiCost: "💰 API Maliyet Takibi",
    since: "{date} tarihinden beri",
    resetBtn: "↺ Sıfırla",
    totalTokens: "toplam token",
    inputTokens: "giriş",
    outputTokens: "çıkış",
    estCost: "tahmini maliyet",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "İpucu:",
    tips: [
      "Dil öğrenirken düzenli kısa seanslar, uzun ama seyrek seanslardan çok daha etkilidir. Her gün birkaç dakika büyük fark yaratır!",
      "Yeni bir kelime öğrenirken onu bir cümle içinde duyun ve kullanın. Bağlam, kelimeyi hafızanıza daha iyi yerleştirir.",
      "Flash kartları atlamayın — aralıklı tekrar sistemi (FSRS) tam olarak doğru zamanda sizi test ederek uzun vadeli hafızayı güçlendirir.",
      "Öğrendiğiniz kelimelerle kendi cümlelerinizi kurmaya çalışın. Aktif kullanım pasif tanımadan çok daha kalıcıdır.",
    ],
  },
  lesson: {
    backBtn: "← Geri",
    topicOf: "Konu {order} / {total} · {words} kelime",
    translating: "Ders hazırlanıyor…",
    newWords: "✨ Yeni Kelimeler ({n})",
    alreadyLearned: "🔄 Zaten Öğrenilenler ({n})",
    practiceDialogue: "🎭 Pratik",
    generateDialogue: "🎭 Bana bir pratik diyalog ver",
    listenSpeakPractice: "🎧 Dinle ve Konuş Laboratuvarı'nda pratik yap",
    generatingDialogue: "Babi diyaloğunu hazırlıyor…",
    newDialogue: "↺ Yeni diyalog",
    lessonSaved: "🎉 Ders kaydedildi! {n} yeni flash kart ekleniyor…",
    alreadyTaken: "✅ Ders zaten alındı",
    markComplete: "✅ Dersi tamamla ve flash kartları kaydet",
    wordProgress: "Kelime {current} / {total}",
    nextWord: "Sonraki Kelime",
    previousWord: "Önceki",
  },
  vocab: {
    structure: "Yapı",
    loadingExample: "Yükleniyor…",
    limitReached: "↺ Sınıra ulaşıldı",
    anotherLeft: "↺ Bir tane daha ({n} kaldı)",
    anotherExample: "↺ Başka bir örnek",
    analyzing: "Analiz ediliyor…",
    analyzed: "✓ Analiz edildi",
    analyzeWord: "🔍 Kelimeyi analiz et",
    analysisIntro: "İşte adım adım dilbilgisi analizi:",
    analysisError: "Analiz yüklenemedi. Lütfen tekrar deneyin.",
    reportMistake: "🚩 Hata Bildir",
    reportWrongMeaning: "Kelime anlamı yanlış",
    reportWrongSentence: "Cümle anlamı yanlış",
    reportOther: "Diğer",
    reportChecking: "Kontrol ediliyor…",
    reportThanks: "✓ İyileştirmemize yardım ettiğin için teşekkürler!",
    reportNoIssue: [
      "Burada bir sorun bulamadım — bu bana doğru görünüyor!",
      "Burada herhangi bir sorun görmüyorum — bu doğru görünüyor.",
      "Benim açımdan her şey yolunda görünüyor.",
      "Herhangi bir sorun tespit edemedim; yazıldığı haliyle doğru görünüyor.",
      "Bu bana iyi görünüyor — herhangi bir endişem yok.",
      "İnceledim ve değiştirilmesi gereken bir şey bulamadım.",
      "Dikkatimi çeken bir sorun olmadı; çeviri doğru görünüyor.",
      "Benim görebildiğim kadarıyla her şey doğru.",
      "Herhangi bir sorun tespit edemedim; bu bana iyi görünüyor.",
    ],
    reportCheckError: "Kontrolü tamamlarken bir sorun yaşadım. Lütfen daha sonra tekrar deneyin.",
    reportOkBtn: "Tamam, anladım",
    reportEscalateBtn: "Bir insan incelemecisine ilet",
    reportEscalatedMsg: "✓ İnceleme ekibimize gönderildi. Teşekkürler!",
    reportAlreadyFlaggedMsg: "✓ Bu zaten inceleme ekibimize bildirildi — teşekkürler!",
  },
  allLessons: {
    title: "📚 Tüm Dersler",
    subtitle: "{count} konu · {words} kelime",
    searchPlaceholder: "🔍 Konu veya kelime ara…",
    noResults: "\"{search}\" ile eşleşen konu yok",
    overwhelmedBanner: "İncelemen gereken {n} kartın var. Yeni derslere başlamadan önce lütfen flash kartlarını gözden geçir.",
    overwhelmedLock: "Önce flash kartları gözden geçir",
    overwhelmedBtn: "Flash Kartlara Git →",
  },
  flashcards: {
    title: "Flash Kartlar",
    cardOf: "Kart {current} / {total}",
    tapToReveal: "Görmek için karta dokun",
    hearIt: "🔊 Dinle",
    hearSentence: "🔊 Cümleyi dinle.",
    allConsolidated: "Hepsi pekiştirildi",
    noDue: "Şu anda vadesi gelen kart yok.\nBelleğin iyi dinlenmiş.",
    backToDashboard: "Ana Sayfaya Dön",
    sessionComplete: "Oturum tamamlandı",
    memoryRetention: "Bellek Verimliliği",
    forgotten: "Unuttum",
    struggled: "Zorlandım",
    recalled: "Hatırladım",
    effortless: "Kolaydı",
    wordsConsolidated: "{retained} / {total} kelime bellekte pekiştirildi",
    wordsInProgress: "{retained} / {total} kelime pekiştiriliyor",
    saveContinue: "Kaydet ve Devam Et",
    tomorrow: "Yarın",
    nDays: "{n} gün",
    d1Title: "Kavrama",
    d1SubSkill: "Okuma ve Dinleme becerilerini geliştirmek için",
    d1Journey: "Yeni kelimeler yolculuğuna burada başlar.",
    d1Due: "{n} tekrar bekliyor",
    d1Listen: "Dinle",
    d1ShowWord: "Kelimeyi Göster",
    d2Title: "Üretim",
    d2SubSkill: "Konuşma ve Yazma becerilerini geliştirmek için",
    d2WillStart: "Daha sonra başlayacak",
    d2Empty: "Kelimeler, Kavrama flash kart setinde iyi öğrenildikten sonra buraya gelir.",
    d2ModalTitle: "Üretim alıştırması açıldı!",
    d2ModalBody: "Bunlar, zaten iyi tanıdığın kelimeler. Şimdi onları üretmeyi öğreniyorsun — {targetLang} dilini anlamaktan gerçekten konuşmaya geçişin yolu bu.",
    d2ModalBtn: "Anladım",
    leaveConfirmTitle: "Kaydedilmemiş tekrar ilerlemesi",
    leaveConfirmBody: "Bu oturumda henüz kaydedilmemiş tekrar ettiğiniz kartlar var. Kaydetmeden şimdi çıkarsanız bu ilerleme kaybolur.",
    leaveConfirmSave: "Kaydet ve çık",
    leaveConfirmDiscard: "Kaydetmeden çık",
    leaveConfirmCancel: "İptal",
    faq: {
      whyTwoQ: "Neden İki Paket?",
      whyTwoA: "Dil öğrenmek, beyninizin farklı şekillerde depoladığı iki ayrı beceriyi içerir: kelimeleri duyduğunuzda veya okuduğunuzda anlamak ve konuşurken veya yazarken üretmek.\n\nFlash kart uygulamalarının çoğu yalnızca bir yönde eğitim yapar. Speafy, ikisini de doğru sırayla eğitir.\n\nKavrama flash kart seti size {targetLang} dilinde bir kelime gösterir ve anlamını hatırlamanızı ister. Bu, dinlerken veya okurken beyninizin kullandığı tanıma becerisini geliştirir.\n\nÜretim flash kart seti size {baseLang} dilinde bir kelime gösterir ve {targetLang} dilinde hatırlamanızı ister. Bu, konuşurken veya yazarken kullandığınız geri çağırma becerisini geliştirir. Daha zordur ve bu zorluk onu etkili yapan şeydir.",
      whyLaterQ: "Üretim Flash Kart Seti Neden Sonra Başlıyor?",
      whyLaterA: "Bellek bilimindeki araştırmalar, bir kelimeyi güvenilir şekilde tanımadan önce üretmeye çalışmanın çaba israfı ve hayal kırıklığına yol açtığını göstermektedir. Speafy, beyninizin Kavrama flash kart seti aracılığıyla bir kelimeyi gerçekten pekiştirene kadar bekler, ardından onu tam doğru anda Üretim setine otomatik olarak tanıtır.",
      whyReturnQ: "Neden Kartlar Geri Geliyor?",
      whyReturnA: "Her kartı puanladığınızda, Speafy bir sonraki tekrarınızı optimal anında planlamak için yıllar süren hafıza araştırmalarına dayanan FSRS adlı bir makine öğrenmesi algoritması kullanır. Her başarılı hatırlama aralığı uzatır. Zamanla kelimeler, günlerden haftalara, aylara uzayarak uzun vadeli belleğinizin kalıcı bir parçası haline gelir.",
    },
  },
  grammarLab: {
    title: "📘 Dilbilgisi Laboratuvarı",
    subtitle: "{count} keşfedilecek dilbilgisi konusu",
    backBtn: "← Geri",
    searchPlaceholder: "🔍 Dilbilgisi konusu ara…",
    noResults: "\"{search}\" ile eşleşen dilbilgisi konusu yok",
    allCategories: "Tüm kategoriler",
    allLevels: "Tüm seviyeler",
    notReviewedLabel: "İncelenmedi",
    reviewedLabel: "İncelendi",
    dueBadge: "{n} tekrar bekliyor",
    explanationLabel: "Açıklama",
    seeReference: "(bkz. {term})",
    ruleLabel: "Kural",
    formsLabel: "Biçimler",
    translatingNote: "Türkçeye çevriliyor...",
    practiceBtn: "▶ Bu konuyu alıştır",
    detailedExplanationBtn: "📖 Ayrıntılı açıklama",
    practiceTitle: "Alıştırma",
    practiceQuestion: "Bunu Türkçe nasıl söylersin?",
    practiceOf: "{total} sorudan {current}.",
    practiceCorrectFeedback: "Doğru!",
    practiceIncorrectFeedback: "Doğru değil — cevap {answer} idi.",
    practiceNext: "Sonraki →",
    practiceDone: "Alıştırma tamamlandı",
    practiceScore: "{total} sorudan {correct} doğru",
    practiceNextReview: "{days} gün sonra tekrar",
    practiceReset: "Bu sefer olmadı — bu konuyu yarın tekrar göreceksin.",
    practiceAgainBtn: "Tekrar alıştır",
    practiceCloseBtn: "Tamam",
    categories: {
      existential: "Varlık Bildirme",
      noun_suffix: "İsim Eki",
      case_suffix: "Hâl Eki",
      verb_conjugation: "Fiil Çekimi",
      question_particle: "Soru Eki",
      copula: "Ek Fiil",
      modal_construction: "Kip Yapısı",
      adjectives: "Sıfatlar",
      case: "Hâl",
      modality: "Kiplik",
      mood: "Kip",
      morphology: "Biçimbilim",
      morphophonology: "Morfofonoloji",
      phonology: "Ses Bilgisi",
      pronouns: "Zamirler",
      register: "Üslup",
      syntax: "Söz Dizimi",
      tense: "Zaman",
      voice: "Çatı",
    },
    points: {
      GP0001: { title: "Varlık ve Bulunma: var / yok", ruleSummary: "[yer/sahip] + [nesne] + var / yok" },
      GP0002: { title: "Çoğul Eki: -ler / -lar", ruleSummary: "isim + -ler (ince) / -lar (kalın)" },
      GP0003: { title: "Bulunma Hâli: -de / -da / -te / -ta", ruleSummary: "isim + -de/-da; sert ünsüzden sonra -te/-ta" },
      GP0004: { title: "Yönelme Hâli: -e / -a", ruleSummary: "isim + -e/-a; ünlüden sonra araya -y- girer" },
      GP0005: { title: "Ayrılma Hâli: -den / -dan / -ten / -tan", ruleSummary: "isim + -den/-dan; sert ünsüzden sonra -ten/-tan" },
      GP0006: { title: "Belirtme Hâli: -i / -ı / -u / -ü (belirli nesne)", ruleSummary: "isim + -i/-ı/-u/-ü; ünlüden sonra araya -y- girer" },
      GP0007: { title: "Şimdiki Zaman — Olumlu: -iyor", ruleSummary: "fiil kökü + -iyor + kişi eki" },
      GP0008: { title: "Şimdiki Zaman — Olumsuz: -mıyor / -miyor / -muyor / -müyor", ruleSummary: "fiil kökü + -mıyor/-miyor/-muyor/-müyor + kişi eki" },
      GP0009: { title: "Şimdiki Zaman — Soru: -iyor mu", ruleSummary: "kök + -iyor + mu(+kişi eki); onlar: kök + -iyorlar + mı" },
      GP0010: { title: "Evet/Hayır Soru Eki: mı / mi / mu / mü", ruleSummary: "[sözcük] + ayrı yazılan mı/mi/mu/mü eki ?" },
      GP0011: { title: "Belirli Geçmiş Zaman: -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "fiil kökü + -di/-dı/-du/-dü (sert ünsüzden sonra -ti/...) + kişi eki" },
      GP0012: { title: "Ek Fiil (Şimdiki Zaman): -(y)ım, -sın, -ø, -(y)ız, -sınız", ruleSummary: "yüklem + -(y)ım / -sın / -ø / -(y)ız / -sınız / (-lar)" },
      GP0013: { title: "İyelik Ekleri: benim / senin / onun / bizim / sizin / onların", ruleSummary: "(benim/senin/...) isim + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "İstek Bildirme: -mek / -mak istemek", ruleSummary: "[mastar -mek/-mak] + istemek (çekimli)" },
      GP0015: { title: "Nazik Rica / 2. Çoğul Emir Kipi: -in / -iniz", ruleSummary: "fiil kökü + -in/-ın/-un/-ün (nazik) ya da -iniz (daha resmî); ünlüden sonra araya -y- girer" },
      GP0016: { title: "Ünsüz Yumuşaması: p/ç/t/k → b/c/d/ğ", ruleSummary: "[p/ç/t/k ile biten, sözlüksel olarak yumuşayan sözcük] + ünlüyle başlayan ek → son ünsüzün yerini b/c/d/ğ alır" },
      GP0017: { title: "Düzensiz Fiil Kökleri: gitmek, etmek, yemek, demek", ruleSummary: "git-→gid-, et-→ed-, ye-→yi-, de-→di- ünlüyle başlayan bir ekten önce" },
      GP0018: { title: "-iyor'dan Önce Ünlü Düşmesi Olan Kökler", ruleSummary: "[vurgusuz -e/-a ile biten fiil kökü] + -iyor → son ünlü düşer, sonra -iyor eklenir" },
      GP0019: { title: "Türkçe Ünlüler", ruleSummary: "8 ünlü: a, e, ı, i, o, ö, u, ü — her biri ince/kalın VE düz/yuvarlak" },
      GP0020: { title: "Ünlü Uyumu", ruleSummary: "Ek ünlüsü sözcüğün son ünlüsüyle uyumlu olur: ince kök → ince ek ünlüsü, kalın kök → kalın ek ünlüsü (4'lü ekler için ayrıca düz/yuvarlak uyumu)" },
      GP0021: { title: "Tamlayan (İlgi) Hâli: -in/-ın/-un/-ün", ruleSummary: "[isim] + in/ın/un/ün (4'lü uyum; isim ünlüyle bitiyorsa araya -n- girer)" },
      GP0022: { title: "İyelik Zamirleri (benim, senin, onun...)", ruleSummary: "Kişi zamiri + ilgi hâli eki: ben→benim, sen→senin, o→onun, biz→bizim, siz→sizin, onlar→onların" },
      GP0023: { title: "Gelecek Zaman: -ecek/-acak", ruleSummary: "[kök] + (y) + ecek/acak (ünlüyle başlayan kişi ekinden önce k→ğ) + kişi" },
      GP0024: { title: "Miş'li Geçmiş Zaman (Rivayet): -miş", ruleSummary: "[kök] + mış/miş/muş/müş (4'lü uyum) + yüklem kişi eki" },
      GP0025: { title: "Şimdiki Zamanın Hikâyesi: -iyordu", ruleSummary: "[-iyor biçimindeki kök] + du/dun/duk/dunuz (3. çoğul için -dı'dan önce -lar eklenir)" },
      GP0026: { title: "Yeterlik: -ebilmek/-abilmek ('yapabilmek') - olumlu", ruleSummary: "[kök] + (y)e/(y)a + bil + ir (bilmek'in kendi sabit geniş zaman istisnası nedeniyle her zaman -ir) + kişi" },
      GP0027: { title: "Sözcük Dizimi", ruleSummary: "Varsayılan: Özne - Nesne/Yer - Yüklem (yüklem sonda). Vurgu için esnek; rol, sözcük sırasıyla değil hâl ekleriyle belirtilir." },
      GP0028: { title: "Bağlaçlar", ruleSummary: "ve, ama, çünkü, veya - değişmez sözcükler, ek çekimi yok" },
      GP0029: { title: "İlgeçler (Edatlar)", ruleSummary: "ile, için, gibi, kadar, önce, sonra - hepsi isimden sonra gelir" },
      GP0030: { title: "Karşılaştırma ve Üstünlük Dereceleri", ruleSummary: "daha + sıfat (karşılaştırma); en + sıfat (üstünlük); [isim-ayrılma hâli] daha [sıfat] = 'isimden daha SIFAT'" },
      GP0031: { title: "Türkçe Zarflar (sıklık/derece)", ruleSummary: "çok, az, hiç (olumsuz fiille kullanılır), bazen, şimdi" },
      GP0032: { title: "Geniş Zaman: -er/-ir/-ar/-ır", ruleSummary: "Çok heceli: [kök]+ir/ır/ur/ür (ünsüzle biten, kurallı) ya da [kök]+r (ünlüyle biten, kurallı). Tek heceli ünsüzle biten: -Ar ile -Ir arasında SÖZLÜKSEL OLARAK BÖLÜNMÜŞ - her fiil için tek tek doğrulayın, tahmin etmeyin." },
      GP0033: { title: "Geniş Zamanın Hikâyesi: -erdi/-ırdı ('eskiden yapardı')", ruleSummary: "[geniş zaman kökü] + di/dı/du/dü (-ir/-ar'ın kendi ünlüsüne göre 4'lü) + kişi" },
      GP0034: { title: "Gelecek Zamanın Hikâyesi: -ecekti/-acaktı ('yapacaktı')", ruleSummary: "[gelecek zaman kökü] + ti (ötümsüz, tekil/1. çoğul) YA DA + ler + di (ötümlü, 3. çoğul; -ler 'r' ile bittiği için ötümsüzleşme yok)" },
      GP0035: { title: "Dilek-Şart Kipi: -se/-sa (yalın kök)", ruleSummary: "[kök] + se/sa (2'li) + kişi (m, n, -, k, niz, ler)" },
      GP0036: { title: "Gereklilik Kipi: -malı/-meli", ruleSummary: "[kök] + malı/meli (2'li) + (y) + yüklem kişi eki" },
      GP0037: { title: "Özne Ortacı: -en/-an ('...an kişi')", ruleSummary: "[kök] + en/an (2'li); ünlüyle biten köklerde araya -y- girer" },
      GP0038: { title: "Zaman Bildiren Yan Cümle: -ince/-ınca ('...dığında')", ruleSummary: "[ünsüzle biten kök] + ince/ınca (2'li, doğrulanmış biçim); ünlüyle biten köklerdeki biçim HENÜZ DOĞRULANMADI" },
      GP0039: { title: "Geçmiş Zamanların Karşılaştırılması", ruleSummary: "-di (tanık olunan) - -miş (rivayet) - -iyordu (yapıyordu) - -irdi (eskiden yapardı)" },
      GP0040: { title: "İşaret Zamirlerinin Hâl Biçimleri: bu/şu/o", ruleSummary: "bu/şu/o + n (kaynaştırma) + hâl eki" },
      GP0041: { title: "Yer Bildiren İşaret Zamirleri: bura/şura/ora", ruleSummary: "bura/şura/ora + hâl eki (sadece yönelme hâlinden önce araya -y- girer)" },
      GP0042: { title: "Soru Sözcükleri", ruleSummary: "ne, kim, nerede, nasıl, kaç, ne zaman, neden - hepsi değişmez" },
      GP0043: { title: "Vasıta Hâli: -(y)le/-(y)la ('ile / aracılığıyla')", ruleSummary: "[isim] + (y)le/(y)la (2'li uyum; ünlüyle bitiyorsa araya -y- girer)" },
      GP0044: { title: "'-lı/-siz' Sıfat Yapan Ekler", ruleSummary: "[isim] + lı/li/lu/lü ('sahip olma') ya da sız/siz/suz/süz ('yoksunluk') - 4'lü uyum" },
      GP0045: { title: "Yetersizlik: -(y)AmA- ('yapamamak')", ruleSummary: "[kök] + (y)e/(y)a + me/ma + olumsuz geniş zaman kişi eki (m/mez-sin/mez/meyiz/mez-siniz/mez-ler)" },
      GP0046: { title: "Gerçek Şart: [geniş zaman kökü] + -se/-sa ('X olursa')", ruleSummary: "[geniş zaman kökü] + se/sa (geniş zaman ekinin kendi ünlüsüne göre 2'li) + kişi" },
      GP0047: { title: "Nesne Ortacı: -DIk + iyelik ('[öznenin] yaptığı')", ruleSummary: "[kök] + DIk (4'lü; sadece ünlüyle başlayan iyelik ekinden önce ğ'ye yumuşar) + iyelik" },
      GP0048: { title: "Gelecek Zaman Ortacının Kullanımı (gelecek zaman biçimlerini yeniden kullanır)", ruleSummary: "Gelecek zaman (see GP0023) ile aynı yüzey biçimler, çekimli fiil yerine isimden önce sıfat olarak kullanılır" },
      GP0049: { title: "Zaman Bildiren Yan Cümleler: -DIğI zaman / -mADIğI zaman / -DIktan sonra", ruleSummary: "[nesne ortacı] + zaman = 'iken/dığında'; [yalın -DIk] + ten + sonra = 'sonra'" },
      GP0050: { title: "-ki Eki (ilgi zamiri işlevli)", ruleSummary: "[bulunma hâlindeki isim / ilgi hâlindeki zamir] + ki (DEĞİŞMEZ - uyum yok)" },
      GP0051: { title: "Süre: -DAn beri / -DIr ('-den beri / -dır')", ruleSummary: "[zaman]+den beri = 'X'ten beri'; [süre]+dir/dır/dur/dür + şimdiki zaman = 'X'tir (hâlâ sürüyor)'" },
      GP0052: { title: "Edilgen Çatı: -Il/-In", ruleSummary: "ünsüzle biten (l hariç): +Il/ıl/ul/ül; l ile biten: +In/ın/un/ün; ünlüyle biten: +n" },
      GP0053: { title: "Ettirgen Çatı: -t/-DIr/-Ir (yalnızca derlenmiş liste - sözlüksel olarak karmaşık)", ruleSummary: "Sözlüksel olarak belirlenen ek biçimi - her fiili ayrı ayrı doğrulayın, genellemeyin" },
      GP0054: { title: "Dönüşlü Çatı: -In/-ın ('kendine yapmak')", ruleSummary: "[kök] + In/ın/un/ün (ünlüden sonra n) - dönüşlü anlam, edilgen çatı (see GP0052) gibi sözlüksel olarak belirlenir" },
      GP0055: { title: "İşteş Çatı: -Iş/-ış ('birbirine yapmak')", ruleSummary: "[kök] + Iş/ış/uş/üş (4'lü) - karşılıklı/ortak eylem" },
      GP0056: { title: "İstek Kipi (bırak ben/hadi): -(y)eyim/-(y)elim", ruleSummary: "[kök] + (y)eyim (1. tekil) / (y)elim (1. çoğul) - 2'li uyum" },
      GP0057: { title: "Anlatı Üslubu: Tekrarlanan -mış (hikâye anlatımı)", ruleSummary: "-mış, anlatı üslubunu sürdürmek için bir hikâye boyunca yalnızca bir kez değil, tekrar tekrar kullanılır" },
      GP0058: { title: "'Ne kadar da' (pekiştireç - 'ne kadar da...!')", ruleSummary: "Ne kadar da + [sıfat] = ünlem bildiren pekiştireç" },
      GP0059: { title: "Durum Bildiren Bağ-Fiil: -ArAk ('yaparak')", ruleSummary: "[kök] + arak/erek (2'li uyum)" },
      GP0060: { title: "Sıralama Bildiren Bağ-Fiil: -Ip ('yapıp')", ruleSummary: "[kök] + Ip/ıp/up/üp (4'lü) - zincirdeki yalnızca son fiil zaman alır" },
      GP0061: { title: "Sebep Bildiren Yan Cümle: -DIğI için ('X olduğu için')", ruleSummary: "[nesne ortacı] (see GP0047) + için (see GP0029) = 'X olduğu için'" },
      GP0062: { title: "'Diye' ('...diye düşünerek/söyleyerek')", ruleSummary: "[cümle] + diye + [ana cümle] = '[cümle] diye düşünerek/bu nedenle, [ana cümle]'" },
      GP0063: { title: "'Olarak' ('X olarak')", ruleSummary: "[isim] + olarak = '[isim] olarak'" },
      GP0064: { title: "'Tarafından' (Edilgen Fiilin Failini Belirten Edat - 'X tarafından')", ruleSummary: "[isim öbeği] + tarafından + [edilgen fiil] (see GP0052)" },
      GP0065: { title: "'Rağmen' ('...e rağmen')", ruleSummary: "[isim + yönelme hâli] (see GP0004) + rağmen = 'X'e rağmen'" },
      GP0066: { title: "'Göre' ('...e göre')", ruleSummary: "[isim/zamir + yönelme hâli] + göre = 'X'e göre'" },
      GP0067: { title: "Yönelme Hâli Tümleçli Yarı Kip Fiilleri", ruleSummary: "[isim/fiil-mA] + yönelme hâli + alışmak/başlamak/çalışmak/karar vermek/izin vermek/benzemek/inanmak/üzülmek" },
      GP0068: { title: "Bilgi Kaynağı Bildiren (Epistemik ve Rivayet) İfadeler", ruleSummary: "gibi geliyor = 'öyle geliyor' (see GP0029) (see GP0007); -mış olmalı = 'yapmış olmalı' (see GP0024) (see GP0036); -mış görünmek = 'yapmış gibi görünmek'; bildiğim kadarıyla = 'bildiğim kadarıyla' (see GP0047) (see GP0029) (see GP0043)" },
      GP0069: { title: "Belirtme Hâlli Nesne Alan Yaygın Fiiller: unutmak, sormak, hatırlamak", ruleSummary: "[isim + belirtme hâli] (see GP0006) + unutmak/sormak/hatırlamak" },
      GP0070: { title: "Konuşmak - Söylemek Karşılaştırması", ruleSummary: "konuşmak = konuşma eylemi (dil/kişi); söylemek = [belirli bir şeyi] söylemek, belirtme hâlli nesne alır" },
    },
  },
  placementTest: {
    title: "🎯 Seviye Testi",
    offerTitle: "Zaten biraz Türkçe biliyor musun?",
    offerBody: "Başlangıç seviyeni bulmak için kısa bir seviye testi çöz — yaklaşık 20 soru. Mevcut Dersini buna göre ayarlayacağız, ancak tüm konular gezinmeye açık kalacak.",
    startBtn: "Teste Başla",
    notNowBtn: "Şimdi Değil",
    roundLabel: "Tur {round} / {totalRounds}",
    questionLabel: "Soru {n} / {total}",
    notSureOption: "Emin değilim",
    notSureHint: "(%100 emin değilsen beşinci seçeneği seç.)",
    wordPrompt: "Bu kelime ne anlama geliyor?",
    listeningPrompt: "Dinle ve duyduğun kelimeyi seç",
    listeningReplay: "Tekrar Oynat",
    preparingRound: "Sorularınız hazırlanıyor…",
    finishBtn: "Sonucumu Gör",
    resultsTitle: "Seviye Testi Sonucun",
    resultsLevel: "{level} seviyesine yerleştirildin",
    resultsBody: "Mevcut Dersin artık bu seviyeden başlıyor. Tüm Derslerden istediğin zaman önceki veya sonraki konulara göz atabilirsin.",
    continueBtn: "Devam Et",
  },
  goals: {
    title: "🎯 Hedeflerim",
    displayName: "Görünen Ad",
    namePlaceholder: "Adın…",
    vocabTarget: "Kelime Hedefi",
    words: "kelime",
    minWords: "min. 1.500",
    midWords: "2.000",
    maxWords: "maks. 3.500",
    courseDuration: "Hedef Kurs Süresi",
    months: "Ay",
    month: "ay",
    monthsPlural: "ay",
    daysSummary: "= {days} gün",
    baseLanguage: "Ana Dil",
    otherLanguage: "Diğer diller (yakında)",
    selectLanguage: "Bir dil seçin…",
    ok: "Tamam",
    langNames: {
      English: "İngilizce", Farsi: "Farsça (Persçe)", Arabic: "Arapça",
      French: "Fransızca", German: "Almanca", Spanish: "İspanyolca",
      Russian: "Rusça", Portuguese: "Portekizce", Chinese: "Çince",
      Turkish: "Türkçe", Hindi: "Hintçe", Italian: "İtalyanca",
    },
    targetLanguage: "Hedef Dil",
    targetLangNames: {
      Turkish: "Türkçe",
    },
    wordsLbl: "kelime",
    wordsPerDay: "kelime/gün",
    daysLbl: "gün",
    saved: "✅ Hedefler kaydedildi!",
  },
  progress: {
    title: "📈 İlerleme",
    memDistTitle: "Bellek Dağılımı · {n} kart",
    inAcquisition: "Edinim Aşamasında",
    rooted: "Kök Saldı",
    fluent: "Akıcı",
    deeplyRetained: "Derinlemesine Tutuldu",
    acqDesc: "< 3 gün kararlılık",
    rootedDesc: "3 – 21 gün kararlılık",
    fluentDesc: "21 – 90 gün kararlılık",
    retainedDesc: "90+ gün kararlılık",
    forecastTitle: "Tekrar Tahmini — Önümüzdeki 15 Gün",
    cardsDue: "Vadesi gelen kartlar",
    today: "Bugün",
    tmrw: "Yarın",
    plusDays: "+{n}g",
    todayFull: "Bugün",
    tmrwFull: "Yarın",
    plusDaysFull: "+{n} gün",
    goalProgress: "Genel Hedef İlerlemesi",
    wordsLearned: "{learned} / {target} kelime öğrenildi",
    vocabGrowth: "Kelime Büyümesi",
    noChart: "Grafiğini görmek için ilk dersini tamamla! 📚",
    wordsLearnedSeries: "Öğrenilen Kelimeler",
    topicRings: "Konu Bellek Halkaları",
    quickStats: "Hızlı İstatistikler",
    dayStreak: "günlük seri 🔥",
    lessonsDone: "ders tamamlandı",
    totalStudy: "toplam çalışma",
    avg14Day: "14 günlük ortalama",
    minUnit: "dk",
    dayLabel: "{n}. Gün",
    cards: "kart",
  },
  myVocab: {
    title: "📝 Kelime Dağarcığım",
    summaryTitle: "{n} Kelimeyle Karşılaşıldı",
    searchPlaceholder: "🔍 Kelimelerini ara…",
    allStatuses: "Tüm durumlar",
    noResults: "\"{search}\" ile eşleşen kelime yok",
    noWords: "Kelime dağarcığını oluşturmaya başlamak için bir ders tamamla! 📚",
    completedTopicsTitle: "Tamamlanan Konular ({n} / {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Acemi",
    wordExplorer: "Kelime Kâşifi",
    wordNerd: "Kelime Delisi",
    wordWizard: "Kelime Sihirbazı",
    rockstar: "Rockstar",
    expert: "Uzman",
    champion: "Şampiyon",
  },
  memStates: {
    inAcquisition: "Edinim Aşamasında",
    rooted: "Kök Saldı",
    fluent: "Akıcı",
    deeplyRetained: "Derinlemesine Tutuldu",
  },
  chat: {
    subtitle: "Yapay Zeka Öğretmenin",
    greetWords: ["Selam", "Merhaba", "Sevgili"],
    greeting: "{greet} {name},\n\nÖğrenmekte olduğun dil hakkında her şeyi sor — dilbilgisi, kelime bilgisi, kültür — ya da bu uygulamayı nasıl kullanacağını.",
    placeholder: "Dil veya uygulama hakkında sor…",
    error: "Üzgünüm, şu an bağlanamadım. Lütfen tekrar dene.",
    escalationFallback: "Üzgünüm, bu konuda tam olarak yardımcı olamadım. Bunu ekibimize ilettim; e-posta yoluyla bir yanıt alacaksın — genellikle 2 iş günü içinde. Ayrıca doğrudan support@speafy.com adresinden bize ulaşabilirsin.",
    welcome: "Merhaba, {name}! 👋 Speafy'ye hoş geldin! Ben Babi, ve burada iki şey için varım: uygulamayı tanımana yardımcı olmak ve {targetLanguage} hakkındaki tüm sorularını yanıtlamak.\n\nGüncel dersle başla ya da Tüm Dersler'den bir konu seç. Her dersi bitirdiğinde tamamlandı olarak işaretlemeyi ve ardından Flash Kartları tekrarlamayı unutma.\n\nİstediğin zaman sor — uygulama hakkında ya da {targetLanguage} hakkında.\n\nÖğrenme yolculuğunda başarılar! 😊",
    lessonLimit: "Bugün zaten {limit} ders tamamladın — harika bir çaba! 🌟\n\nÖğrenmenin sürdürülebilir olması için günlük {limit} ders sınırı var.\n\nBeyninize bugün öğrendiklerini pekiştirmesi için zaman tanı. Bunun yerine bir Flash Kart tekrar oturumu neden olmasın?\n\nYarın daha fazlası için hazır olduğunda burada olacağım! 😊",
    streakDecayed: "Tekrar hoş geldin! 👋 {days} gün uzak kaldın. Kazandığın {protection} Seri Koruma Günü 🛡️ sayesinde serin tamamen sıfırlanmak yerine sadece {oldStreak}'ten {newStreak}'e düştü. Hadi inşa etmeye devam edelim!",
    streakWiped: "Tekrar hoş geldin! 👋 {days} gün uzak kaldın — bu, biriktirdiğin {protection} Seri Koruma Günü'nden 🛡️ fazlaydı, bu yüzden serin 1'den yeniden başladı. Her seri bir yerden başlar — hadi yeniden inşa edelim!",
    weeklyRecapFallback: "Selam! 👋 Sana haftalık özetini getirmek istedim ama şu anda hazırlamakta sorun yaşıyorum. Yine de hızlıca söyleyeyim — {streak} günlük serin devam ediyor, böyle devam et! 🔥",
    dailyPlanQuestion1: "Selam! 👋 Bugün çalışmak için ne kadar vaktin var?",
    dailyPlanQuestion2: "Merhaba! 😊 Senin için bir çalışma planım var — bugün kaç dakika ayırabilirsin?",
    dailyPlanQuestion3: "Bugünün planına hazır mısın? 🎯 Bana yaklaşık ne kadar vaktin olduğunu söyle yeter.",
    dailyPlanClarify: "Üzgünüm, tam anlayamadım! Bana yaklaşık bir sayı verebilir misin, mesela '20' ya da '30 dakika'?",
    dailyPlanUnreasonable: "Bu pek tipik bir çalışma seansına benzemiyor! Bana 5 dakika ile yaklaşık 5 saat arasında bir değer verebilir misin?",
    dailyPlanGiveUp: "Sorun değil — hazır olduğunda Flash Kartlar'a ya da Güncel Dersine gidip başlayabilirsin! 😊",
    dailyPlanFallback: "Uygun vaktini not aldım ama şu anda bugünün planını hazırlamakta sorun yaşıyorum. Bu arada, süresi gelmiş kartların varsa Flash Kartlar her zaman iyi bir seçenektir! 😊",
    sendBtn: "Gönder",
    askBabi: "Babi'ye Sor",
    voiceConsentTitle: "Babi ile sesli sohbeti açmak ister misiniz?",
    voiceConsentBody: "Babi, sizi duymak için mikrofonunuzu ve yanıt vermek için hoparlörünüzü kullanacak. Konuşmanız metne dönüştürülür — ses kaydının kendisi asla saklanmaz. Metin en fazla 30 gün saklanabilir. Ayrıntılar için Gizlilik Politikamıza bakın.",
    voiceConsentPrivacyLink: "Gizlilik Politikası",
    voiceConsentAllow: "Mikrofona izin ver",
    voiceConsentDecline: "Şimdi değil",
    voiceDenied: "Mikrofon erişimi olmadan sesli sohbet kullanılamaz. Yazarak sohbete devam edebilirsiniz — tekrar denemek için istediğiniz zaman mikrofon simgesine dokunun.",
    voiceDeviceInUse: "Mikrofonunuz başka bir yerde kullanılıyor gibi görünüyor — onu kullanan diğer uygulamaları kapatıp tekrar deneyin.",
    voiceError: "Sesli sohbette bir sorun oluştu. Lütfen tekrar deneyin.",
    voiceStarting: "Başlatılıyor… lütfen bekleyin",
    voiceListening: "Dinliyorum…",
    voiceProcessing: "Anlıyorum…",
    voiceReviewHint: "Düzenlemek için dokunun, aksi halde bu birkaç saniye içinde otomatik olarak gönderilecek.",
    voiceSendNow: "Şimdi gönder",
    voiceDiscard: "Vazgeç",
    voiceEditTranscript: "Babi'nin duyduğunu düzenle",
    voiceBadgeLabel: "Sesle gönderildi",
    voiceDidntCatch: "Anlayamadım — tekrar denemek için mikrofona dokun.",
    voiceSpeaking: "Babi konuşuyor…",
    voiceTtsUnavailable: "Bu yanıt için ses mevcut değildi — bunun yerine metin gösteriliyor.",
    voiceTtsUnavailableLanguage: "Babi'nin sesli yanıtı henüz {language} dilinde mevcut değil.",
    voiceTapToHear: "Babi'nin yanıtını duymak için dokun",
    voiceNotEntitled: "Babi ile sesli sohbet premium bir özelliktir — kullanmak için yükseltme yapın.",
    voiceNoBalance: "Bu dönem için tüm sesli dakikalarınızı kullandınız. Bir sonraki dönemde yenilenecek.",
    voiceOtherTabActive: "Sesli sohbet başka bir sekmede zaten etkin.",
    voiceLowBalanceNudge: "Bu dönem için sesli dakikalarınız azalıyor.",
    voiceLowMinutesHeadsUp: "Bu dönem için sesli dakikalarınız azalıyor.",
    voiceGetMoreMinutes: "Daha fazla dakika al",
    voiceStopBtn: "Durdur",
    voiceMicButtonLabel: "Sesli sohbet",
    voiceBannerDismiss: "Kapat",
  },
  settings: {
    title: "Ayarlar",
    accountSection: "Hesap",
    linkedGoogle: "Google ile Bağlı",
    emailAccountBadge: "E-posta hesabı",
    changeNameBtn: "Kullanıcı adını değiştir",
    nameSaveBtn: "Kaydet",
    nameCancelBtn: "İptal",
    nameSaving: "Kaydediliyor…",
    passwordLabel: "Şifre",
    passwordSub: "E-postana bir sıfırlama bağlantısı gönder",
    passwordSent: "Gönderildi ✓",
    passwordResetBtn: "Sıfırla",
    subscriptionSection: "Abonelik",
    subscriptionAdminLabel: "Yönetici Hesabı",
    subscriptionAdminSub: "Tüm özelliklere tam ve kalıcı erişiminiz var.",
    subscriptionReviewerLabel: "İnceleyici Erişimi",
    subscriptionReviewerSub: "Uygulama incelemecisi olarak tüm özelliklere ücretsiz erişiminiz var.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Yıllık",
    subscriptionPlanMonthly: "Aylık",
    subscriptionRenews: "{date} tarihinde yenilenecek",
    subscriptionActive: "Aktif",
    subscriptionManageLink: "Fatura ve Ödemeler",
    subscriptionCancelLink: "Aboneliği iptal et veya duraklat",
    subscriptionPaymentFailedLabel: "Son ödemeniz başarısız oldu",
    subscriptionPaymentFailedSub: "Ödeme {date} tarihinde başarısız oldu",
    subscriptionPaymentFailedSubNoDate: "Pro erişiminizi korumak için lütfen ödeme yönteminizi güncelleyin",
    subscriptionUpdatePaymentLink: "Ödeme yöntemini güncelle ↗",
    subscriptionCancelledPending: "Planınız {date} tarihinde sona eriyor — o zamana kadar Pro erişiminizi koruyacaksınız",
    subscriptionPausedLabel: "Abonelik duraklatıldı",
    subscriptionPausedSub: "{date} tarihinde otomatik olarak devam eder — erken devam ettirmezseniz yeni bir dönem için tam ücret tahsil edilir",
    subscriptionPausedSubNoDate: "3 ay sonra otomatik olarak devam eder — erken devam ettirmezseniz",
    subscriptionResumeBtn: "Şimdi devam ettir",
    subscriptionResuming: "Devam ettiriliyor…",
    pausePendingLabel: "Duraklatma planlandı",
    pausePendingSub: "Mevcut fatura döneminizin sonunda, {date} tarihinde yürürlüğe girer",
    manageOfferTitle: "İptal etmeyi mi düşünüyorsunuz?",
    manageOfferSub: "Bunun yerine duraklatın — {date} tarihine kadar ilerlemenizi korursunuz, ardından 3 ay sonra abonelik otomatik olarak devam eder ve erken devam ettirmezseniz yeni bir dönem için tam ücret tahsil edilir.",
    manageOfferPauseBtn: "Bunun yerine duraklat",
    manageOfferContinueLink: "Yine de iptal et",
    manageOfferDismiss: "Vazgeçtim",
    pauseOfferLabel: "Bir molaya mı ihtiyacınız var?",
    pauseOfferSub: "Aboneliğinizi iptal etmek yerine 3 ay duraklatın — ilerlemenizi koruyun, istediğiniz zaman devam ettirin.",
    pauseOfferBtn: "Aboneliği duraklat",
    pauseConfirmP1: "Speafy Pro aboneliğiniz duraklatılsın mı?",
    pauseConfirmC1: "Mevcut fatura döneminiz {date} tarihine kadar devam eder — zaten ödediğiniz her şeyi korursunuz.",
    pauseConfirmC2: "Duraklatma sırasında yeni Dersler kilitlenir (süresi dolmuş ücretsiz plan gibi), ancak mevcut Kartlarınızı normal şekilde tekrar edebilirsiniz.",
    pauseConfirmC3: "Duraklatma sabit 3 ay sürer. Bu süre dolmadan manuel olarak devam ettirmezseniz, aboneliğiniz otomatik olarak devam eder ve yeni bir dönem için tam ücret tahsil edilir.",
    pauseConfirmBtn: "Duraklatmayı onayla",
    pausing: "Duraklatılıyor…",
    pauseFailedGeneric: "Aboneliğiniz duraklatılırken bir sorun oluştu. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.",
    manageLinkLoading: "Yükleniyor…",
    manageLinkFailedGeneric: "Şu anda bir yönetim bağlantısı yüklenemedi. Lütfen tekrar deneyin.",
    resumeConfirmP1: "Speafy Pro aboneliğiniz şimdi devam ettirilsin mi?",
    resumeConfirmC1: "Hemen yeni bir fatura dönemi için tam ücret tahsil edilir.",
    resumeConfirmBtn: "Evet, şimdi devam ettir",
    resumeFailedGeneric: "Aboneliğiniz devam ettirilirken bir sorun oluştu. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.",
    subscriptionLastCharge: "Son ödeme: {date} tarihinde {amount} — {status}",
    subscriptionLastChargePaid: "Ödendi",
    subscriptionLastChargeFailed: "Başarısız",
    tierChangePendingLabel: "Plan değişikliği planlandı",
    tierChangePendingToElite: "{date} tarihinde Elite'e geçilecek",
    tierChangePendingToBasic: "{date} tarihinde, mevcut fatura döneminizin sonunda Pro'ya geçilecek",
    tierUpgradeToEliteLink: "Elite'e yükselt",
    tierDowngradeToBasicLink: "Pro'ya geri dön",
    tierUpgradeConfirmTitle: "Elite'e yükseltilsin mi?",
    tierUpgradeConfirmSub: "Bugün orantılı fark tahsil edilecek ve Elite'in Babi ile 3 saatlik sesli konuşma hakkına hemen kavuşacaksınız — bundan sonra {price}/{interval}.",
    tierDowngradeConfirmTitle: "Pro'ya geri dönülsün mü?",
    tierDowngradeConfirmSub: "{date} tarihine kadar Elite'i koruyacaksınız, ardından bir sonraki fatura tarihinizde Pro'ya geçeceksiniz — bugün ücret alınmaz.",
    tierUpgradeConfirmBtn: "Evet, şimdi yükselt",
    tierDowngradeConfirmBtn: "Evet, Pro'ya dön",
    tierChangeBusy: "Güncelleniyor…",
    tierChangeFailedGeneric: "Planınızı değiştirirken bir sorun oluştu. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.",
    voiceMinutesLabel: "Sesli dakikalar ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Deneme",
    voiceTierAdmin: "Yönetici",
    voiceTierViewer: "İzleyici",
    voiceMinutesUsed: "Bu dönem {limit} dakikanın {used} kullanıldı",
    voiceMinutesPurchasedExtra: "Ayrıca {extra} satın alınmış — aylık dakikaların bitince kullanılır ve hiç sona ermez",
    yourDataSection: "Verileriniz",
    marketingLabel: "Pazarlama İletişimleri Onayı",
    marketingSub: "Güncellemeler, bildirimler ve özel teklifler",
    voiceConsentLabel: "Babi ile Sesli Sohbet",
    voiceConsentSub: "Babi'nin sizi duymasına ve sesli yanıt vermesine izin verin",
    privacyLegalSection: "Gizlilik, Şartlar ve Yasal",
    privacyPolicyLabel: "Gizlilik Politikası",
    privacyPolicySub: "Verilerinizi nasıl topladığımız, kullandığımız ve koruduğumuz",
    viewLink: "Görüntüle",
    termsLabel: "Kullanım Şartları",
    termsSub: "Kullanımınızı düzenleyen kurallar ve koşullar",
    refundLabel: "İade Politikası",
    refundSub: "Uygunluk ve iade talebinde bulunma şekli",
    cookieSettingsLabel: "Çerez Ayarları",
    cookieSettingsSub: "Analitik ve işlevsel çerezleri yönetin",
    manageLink: "Yönet",
    privacySection: "Gizlilik ve Veriler",
    exportLabel: "Verilerimi dışa aktar",
    exportSub: "Profil, ilerleme ve flash kartlarınızın JSON dosyasını indirin",
    exportBtn: "Dışa Aktar",
    exportDone: "✓ İndirildi",
    cacheLabel: "Yerel önbellek",
    cacheSub: "Öğrenme ilerlemesi ve örnek cümleler hız için tarayıcınızda önbelleğe alınır.",
    cookieLabel: "Çerez ve gizlilik ayarları",
    cookieSub: "Analitik ve çerez tercihleri Speafy web sitesinde yönetilir",
    privacyLink: "Gizlilik politikası ↗",
    aboutSection: "Hakkında",
    aiTutorLabel: "Yapay zeka öğretmeni",
    aiTutorSub: "Claude Sonnet tarafından desteklenmektedir — Anthropic",
    algoLabel: "Bellek algoritması",
    algoSub: "FSRS v4.5 — Ücretsiz Aralıklı Tekrar Zamanlayıcısı",
    learningSection: "Öğrenme",
    placementTestLabel: "Seviye testi",
    placementTestSubNew: "Kısa bir testle başlangıç seviyeni bul",
    placementTestSubRetake: "Son yerleştirme: {level} · istediğin zaman tekrar alabilirsin",
    placementTestBtnNew: "Teste Başla",
    placementTestBtnRetake: "Testi Tekrarla",
    versionLabel: "Sürüm",
    appearanceSection: "Görünüm",
    darkModeLabel: "Karanlık mod",
    darkModeSub: "Koyu renk şemasına geç",
    largeTextLabel: "Büyük metin",
    largeTextSub: "Daha kolay okuma için metin boyutunu artırır",
    babiCheckinsSection: "Babi Kontrolleri",
    babiDailyNudgeLabel: "Babi'nin günlük hatırlatması",
    babiDailyNudgeSub: "Babi ne kadar vaktin olduğunu sorar ve her gün bir çalışma planı önerir",
    babiWeeklyReportLabel: "Babi'nin haftalık raporu",
    babiWeeklyReportSub: "İlerlemenin haftalık özeti, haftada bir kez",
    dangerSection: "Tehlikeli Bölge",
    resetLabel: "Tüm ilerlemeyi sıfırla",
    resetSub: "Serinizi, flash kartlarınızı ve ders geçmişinizi siler. Geri alınamaz.",
    resetBtn: "Sıfırla",
    resetConfirmP1: "Tüm ilerleme sıfırlansın mı? Bu kalıcı olarak siler:",
    resetConfirmC1: "Tüm {n} flash kart ve bellek verileri",
    resetConfirmC2: "Seriniz ({n} gün) ve çalışma geçmişiniz",
    resetConfirmC3: "Öğrendiğiniz her dildeki tüm ders tamamlama kayıtları",
    resetConfirmC4: "Dilbilgisi Laboratuvarı'ndaki tekrar ilerlemeniz",
    resetConfirmP2: "Hesabınız, adınız ve dil ayarlarınız korunacak.",
    resetConfirmBtn: "Evet, her şeyi sıfırla",
    resetting: "Sıfırlanıyor…",
    resetDone: "✅ İlerleme sıfırlandı! Baştan başlıyorsunuz.",
    deleteLabel: "Hesabı sil",
    deleteSub: "Hesabınızı ve tüm verilerinizi kalıcı olarak siler. Geri alınamaz.",
    deleteBtn: "Hesabı sil",
    deleteConfirmP1: "Speafy hesabınız kalıcı olarak silinsin mi? Bu, hemen ve geri alınamaz şekilde silecektir:",
    deleteConfirmC1: "Profiliniz (ad, dil, hedefler)",
    deleteConfirmC2: "Tüm {n} flash kart ve bellek verileri",
    deleteConfirmC3: "Tüm öğrenme geçmişiniz ve seriniz",
    deleteConfirmC4: "Firebase kimlik doğrulama hesabınız",
    deleteConfirmPrompt: "Onaylamak için DELETE (büyük harfle) yazın:",
    deleteConfirmBtn: "Hesabımı kalıcı olarak sil",
    deleting: "Siliniyor…",
    cancelBtn: "İptal",
  },
  trial: {
    daysLeftBadge: "⏱ {n} gün kaldı",
    expiredBadge: "Deneme bitti · Yükselt ↑",
    pausedBadge: "⏸ Duraklatıldı",
    proBadge: "✦ Pro Plan",
    eliteBadge: "✦ Elite Plan",
  },
  paywall: {
    back: "← Geri",
    title: "Speafy Pro'ya Yükselt",
    subTrialExpired: "Ücretsiz deneme süreniz doldu. Öğrenmeye devam etmek için yükseltin.",
    subDefault: "Tüm dersleri ve flash kart tekrarını açın.",
    features: [
      "Tüm {count} ders tamamen açık",
      "Babi, yapay zeka öğretmeninizle sınırsız sohbet",
      "Akıllı FSRS flash kart tekrarı",
      "İlerleme takibi ve bellek analitikleri",
      "Her kelimede native ses",
      "Pratik diyaloglar",
      "Çok dilli uygulama arayüzü",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Speafy Pro'daki her şey",
      "Dinle ve Konuş Laboratuvarı — Babi ile rehberli konuşma pratiği",
      "Her ay Babi ile 3 saat sesli konuşma",
      "İstediğiniz zaman ek sesli dakika satın alın — saatte 3$",
    ],
    billingMonthly: "Aylık",
    billingYearly: "Yıllık",
    saveBadge: "%25 tasarruf",
    pricePerMonth: "/ay",
    priceBilledYearly: "yıllık faturalandırılır",
    cta: "Speafy Pro'yu Başlat →",
    ctaElite: "Speafy Elite'i Başlat →",
    fine: "İstediğinizde iptal edin · Paddle üzerinden güvenli ödeme",
    bannerExpired: "Ücretsiz deneme süreniz doldu.",
    bannerActive: "Ücretsiz deneme — {n} gün kaldı.",
    bannerBtn: "Yükselt ↑",
    settingsFreePlan: "Ücretsiz Plan",
    pausedTitle: "Aboneliğiniz duraklatıldı",
    pausedSub: "Yeni derslerin kilidini tekrar açmak için Ayarlar'dan aboneliğinizi devam ettirin.",
    pausedGoToSettingsBtn: "Ayarlara git",
    alreadyProTitle: "Zaten Pro'sunuz!",
    alreadyProSub: "Aboneliğiniz aktif — tekrar satın almanıza gerek yok.",
    alreadyProGoHomeBtn: "Ana Sayfaya Git",
    settingsTrialRemaining: "Deneme — {n} gün kaldı",
    settingsTrialEnded: "Deneme bitti — tüm dersleri açmak için yükseltin",
    settingsFreeForever: "Kaldığın yerden devam et — tüm dersleri açmak için yükselt",
    settingsUpgradeBtn: "Yükselt",
  },
  search: {
    trigger: "Ara",
    title: "🔍 Ara",
    close: "✕ Kapat",
    clear: "Aramayı temizle",
    placeholder: "Kelime, konu, dilbilgisi ara…",
    emptyPrompt: "Kelime, konu ve dilbilgisi konularında aramak için yazmaya başla.",
    noResults: "\"{search}\" ile eşleşen sonuç yok",
    resultsLabel: "Arama sonuçları",
    topicsLabel: "Konular",
    wordsLabel: "Kelimeler",
    grammarLabel: "Dilbilgisi",
    badgeTopic: "Konu",
    badgeWord: "Kelime",
    badgeGrammar: "Dilbilgisi",
    proTag: "Pro",
  },
  authAction: {
    verifyingTitle: "E-postanız doğrulanıyor…",
    verifiedTitle: "E-postanız doğrulandı!",
    verifiedBody: "Her şey hazır. Öğrenmeye devam etmek için Speafy'ye dönün.",
    continueBtn: "Speafy'ye devam et →",
    verifyErrorTitle: "Bu bağlantının süresi doldu",
    verifyErrorBody: "Bu doğrulama bağlantısı artık geçerli değil. Giriş yapın, size yeni bir tane gönderelim.",
    resendBtn: "Doğrulama e-postasını yeniden gönder",
    resendSent: "Gönderildi ✓",
    resendError: "Yeniden gönderilemedi. Lütfen biraz sonra tekrar deneyin.",
    signInBtn: "Giriş yap",
    verifyingReset: "Bağlantınız kontrol ediliyor…",
    resetTitle: "Şifrenizi sıfırlayın",
    resetBodyFor: "{email} için yeni bir şifre seçin",
    newPasswordPh: "Yeni şifre",
    confirmPasswordPh: "Yeni şifreyi onaylayın",
    resetSubmitBtn: "Şifreyi sıfırla",
    resettingBtn: "Sıfırlanıyor…",
    resetSuccessTitle: "Şifre güncellendi!",
    resetSuccessBody: "Şifreniz değiştirildi. Yeni şifrenizle giriş yapın.",
    resetErrorTitle: "Bu bağlantının süresi doldu",
    resetErrorBody: "Bu şifre sıfırlama bağlantısı artık geçerli değil. Giriş ekranından yeni bir tane isteyin.",
    passwordMismatch: "Şifreler eşleşmiyor.",
    passwordTooShort: "Şifre en az 6 karakter olmalıdır.",
    genericError: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    invalidTitle: "Bu bağlantı geçersiz veya süresi dolmuş",
    invalidBody: "Takip ettiğiniz bağlantı artık geçerli değil. Lütfen Speafy'ye dönüp tekrar deneyin.",
    backToSignIn: "Girişe dön",
  },

  affiliate: {
    disclosure: {
      text: "Bilginize: Speafy'ye benim bağlantım üzerinden kaydolursanız, küçük bir komisyon kazanırım — bu size hiçbir ek maliyet getirmez.",
      reviewed: false,
    },
    // Promo message a teacher copies to recruit their students. FINALIZED + native-verified
    // (reviewed: true). `{{referral_link}}` is a LITERAL placeholder — the dashboard / pitch
    // page substitutes the real link at send time; i18n t()'s single-brace {x} interpolation
    // never touches double-brace tokens.
    promoTemplate: {
      text: "Herkese merhaba! Derslerimize harika bir katkı sağlayan bir uygulamayı önermek istiyorum: Speafy. Birlikte çalıştığımız konuları birebir takip ediyor ve Babi adlı yapay zekâ sohbet arkadaşıyla istediğiniz zaman konuşma pratiği yapabiliyorsunuz. Başlaması ücretsiz ve ben haftalık olarak ilerleme raporunuzu alacağım — böylece derslerimiz arasında nasıl gittiğinizi görebilirim. Bana öğretmeniniz olarak bağlanmanız için lütfen bu bağlantı üzerinden kaydolun: {{referral_link}}",
      reviewed: true,
    },
  },

  teacherDash: {
    link: "Öğretmen Paneli",
    title: "Öğretmen Paneli",
    backHome: "Ana sayfaya dön",
    studentBadge: "Öğretmenin: {name}",
    intro: "Öğrencilerini Speafy'ye getirmek ve ilerlemelerini takip etmek için ihtiyacın olan her şey.",
    referralTitle: "Davet bağlantın",
    referralBody: "Bu bağlantıyı öğrencilerinle paylaş. Bu bağlantıdan kaydolan herkes öğretmeni olarak sana bağlanır.",
    copy: "Bağlantıyı kopyala",
    copied: "Kopyalandı",
    shareText: "Speafy'de bana katıl, birlikte bir dil öğrenelim! {link}",
    shareTelegramText: "Speafy'de bana katıl, birlikte bir dil öğrenelim!",
    shareEmailSubject: "Speafy'de bana katıl",
    shareWhatsapp: "WhatsApp",
    shareTelegram: "Telegram",
    shareEmail: "E-posta",
    shareSms: "SMS",
    shareMore: "Daha fazla",
    studentsTitle: "Öğrencilerin",
    studentsLoading: "Öğrencilerin yükleniyor…",
    studentsError: "Öğrencilerini şu anda yükleyemedik.",
    retry: "Tekrar dene",
    studentsEmpty: "Henüz öğrencin yok. Davet bağlantını paylaş — bu bağlantıdan katılan öğrenciler burada görünür.",
    colName: "Öğrenci",
    colJoined: "Katılma",
    colStatus: "Abonelik",
    colCommission: "Kazanılan komisyon",
    colGrammar: "Dilbilgisi odağı",
    statusActive: "Etkin",
    statusTrial: "Deneme",
    statusNone: "Aboneliği yok",
    commissionNote: "Bu, her öğrenciden toplamda kazandığın tutardır. Ödeme için kullanılabilir bakiyen aşağıda gösteriliyor.",
    commissionCapReached: "12 aylık süre sona erdi",
    grammarNote: "Dilbilgisi hatası verileri yalnızca aktif aboneliği olan öğrenciler için gösterilir.",
    studentUnnamed: "Öğrenci",
    curriculumTitle: "Müfredat referansı",
    curriculumBody: "Öğrencilerinin öğrendiği tüm konuları ve kelimeleri sırayla incele.",
    curriculumLink: "Müfredat referansını aç",
    profileTitle: "Öğretmen profilin",
    profileBody: "Speafy öğretmen dizini yayınlandığında dizinde bu şekilde görüneceksin.",
    profileBio: "Kısa tanıtım",
    profileBioPh: "Kendin ve nasıl öğrettiğin hakkında bir iki cümle.",
    profilePhoto: "Fotoğraf",
    photoChoose: "Fotoğraf seç",
    photoUploading: "Yükleniyor…",
    photoRemove: "Kaldır",
    photoHint: "PNG veya JPG, en fazla 200 KB.",
    photoTypeErr: "Lütfen bir PNG veya JPG görseli seç.",
    photoSizeErr: "Bu görsel 200 KB'den büyük — lütfen daha küçük birini seç.",
    photoUploadErr: "Yükleme başarısız oldu. Lütfen tekrar dene.",
    profileLink: "Kişisel web sitesi veya sosyal medya bağlantısı",
    profileLinkPh: "www.ornek.com",
    profileLanguages: "Öğrettiğim diller",
    profileLanguagesHint: "Öğrettiğin dilleri seç. Speafy bunları kurs dili olarak ekledikçe yeni seçenekler açılır.",
    profileLanguagesSoon: "Yakında",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    saved: "Kaydedildi",
    urlError: "Bu bir web adresine benzemiyor. Kontrol et veya alanı boş bırak.",
    termsStatusAccepted: "Öğretmen Ortaklığı Şartları — {date} tarihinde kabul edildi",
    termsStatusPending: "Öğretmen Ortaklığı Şartları — Henüz kabul edilmedi",
    termsVersionLabel: "Sürüm {version}",
    termsView: "Kabul edilen Şartları görüntüle",
    payoutTitle: "Ödeme",
    payoutLoading: "Ödeme durumun yükleniyor…",
    payoutError: "Ödeme durumunu şu anda yükleyemedik.",
    payoutBalance: "Güncel bakiyen: {balance}",
    payoutNotEligible: "Bakiyen {threshold} tutarına ulaştığında ödeme talep edebileceksin.",
    payoutAlreadyRequested: "Ödeme talep edildi — seninle iletişime geçeceğiz.",
    requestPayoutBtn: "Ödeme Talep Et",
    payoutRequestFailed: "Talebin gönderilirken bir sorun oluştu. Lütfen tekrar dene.",
    payoutConfirmTitle: "Ödeme talep edilsin mi?",
    payoutConfirmBody: "Şu anda talep edebileceğin {balance} bakiyen var.\n\nBu, manuel bir ödeme sürecini başlatır — hiçbir para otomatik olarak aktarılmaz. Talebini inceleyip e-posta yoluyla sana dönüş yapacağız.",
    payoutConfirmBtn: "Ödeme Talep Et",
    payoutConfirmCancel: "Vazgeç",
  },

  teacherTerms: {
    screenTitle: "Öğretmen Ortaklığı Şartları",
    contents: "İçindekiler",
    lastUpdatedLabel: "Son güncelleme",
    effectiveLabel: "Yürürlük tarihi",
    bannerTitle: "İşlem gerekli",
    bannerBody: "Ortak olarak devam etmek için lütfen Öğretmen Ortaklığı Şartlarını inceleyip kabul edin.",
    bannerCta: "İncele ve kabul et",
    acceptedOn: "Bu Şartları {date} tarihinde kabul ettiniz.",
    acceptedVersion: "Kabul edilen sürüm: {version}",
    accepting: "Kabulünüz kaydediliyor…",
    acceptError: "Kabulünüzü şu anda kaydedemedik. Lütfen tekrar deneyin.",
    draftNotice: "Bu Şartlar henüz kesinleşmedi. Yürürlük tarihi belirlendiğinde kabul edebileceksiniz.",
  },
};

export default tr;
